module.exports = __webpack_public_path__ + "img/fotos.a243e150.jpg";